import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class HandShake extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d={`M12.1,16.3C12,16.1,11.7,16,11.5,16c-0.2,0-0.4,0.1-0.5,0.2c-0.6,0.5-1.2,1.1-1.8,
                        1.8c-0.3,0.3-0.2,0.7-0.1,0.9c0.2,0.3,0.4,0.5,0.9,0.5c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,
                        0.3-0.2c0.7-0.7,1.3-1.3,1.8-1.9C12.5,17.1,12.5,16.6,12.1,16.3z`}
                />
                <path
                    d={`M17.3,11.5c-0.8-0.7-1.5-1.3-2.3-1.9c-0.3-0.2-0.5-0.4-0.8-0.7c-0.3,0.2-0.5,
                        0.4-0.8,0.6c-0.7,0.5-1.4,1-2.1,1.5c-0.4,0.3-0.8,0.4-1.4,0.4c0,0,0,0,0,0c-0.1,
                        0-0.2,0-0.3,0C9,11.3,8.4,11,8,10.5c-0.3-0.4-0.5-0.9-0.5-1.4c0-0.3,0.2-0.6,0.4-0.8
                        c0.9-0.9,1.8-1.7,2.7-2.6c0.3-0.2,0.5-0.5,0.8-0.7c0,0-0.1,0-0.1,0c-0.2,0-0.4-0.1-0.6-0.1c-1.2,0-2.4,0.3-3.5,0.6L6.8,5.5
                        C6.5,5.6,6.1,5.7,5.8,5.7C4.9,5.7,4.1,5.5,3.3,5C3.2,4.9,3,4.9,2.9,4.9c-0.1,0-0.3,0-0.5,0.4c-0.2,0.5-0.5,1-0.7,1.5
                        c-0.5,1.1-1,2.2-1.5,3.3c-0.1,0.1-0.1,0.3-0.2,0.5c0,0,0,0,0,0.1c1,0.4,1.7,1.2,2.5,1.9c0,0,0.1,0.1,0.1,0.1
                        c0.1-0.1,0.2-0.3,0.4-0.4c0.4-0.4,0.7-0.8,1.1-1.2c0.3-0.3,0.6-0.4,0.9-0.4c0.1,0,0.3,0,0.4,0.1c0.6,0.1,1,0.5,1.3,1.2
                        c0.1,0.2,0.1,0.2,0.3,0.2l0,0c0.6,0,1.1,0.2,1.4,0.6c0.2,0.2,0.3,0.4,0.4,0.7c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.3,0,0.4,0
                        c1,0,1.4,0.5,1.9,1.4l0.1,0c0.6,0,1.1,0.2,1.5,0.5c0.3,0.3,0.5,0.8,0.5,1.5c0,0.2-0.1,0.5-0.3,0.7c-0.4,0.4-0.8,0.8-1.2,1.2
                        c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0.1,0,0.1,0c0.2,0,0.3,0.1,0.4,0.1c0,0,0.1,0,0.1,0c0.6-0.1,0.8-0.6,1.1-1.1l0.1-0.1l0.1,0
                        c0.2,0,0.3,0,0.5,0c0.8,0,1-0.3,1.3-1.1l0-0.1l0.1,0c0.2,0,0.3,0,0.5,0c0.4,0,0.7,0,1-0.1c0.5-0.1,0.6-0.6,0.7-1.1l0-0.1l0.2,0
                        c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0c0.4,0,0.7-0.1,0.9-0.3c0.2-0.2,0.3-0.6,0.2-1.1c0-0.2-0.2-0.5-0.3-0.7
                        C18.6,12.9,18,12.1,17.3,11.5z`}
                />
                <path
                    d={`M23.9,10.1L23,8.3c-0.5-1.1-1-2.2-1.5-3.2c-0.1-0.3-0.3-0.3-0.3-0.3c-0.1,0-0.2,0-0.3,0.1c-0.9,0.6-1.9,0.9-2.8,0.7
                        c-0.8-0.1-1.5-0.3-2.2-0.5c-0.2,0-0.3-0.1-0.5-0.1c-0.4-0.1-0.8-0.2-1.2-0.4c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1,0-0.2,0.1-0.2,0.1
                        c-0.2,0.1-0.4,0.2-0.5,0.3c-0.8,0.7-1.5,1.4-2.3,2c-0.7,0.6-1.3,1.2-2,1.8C8.6,9,8.5,9.1,8.6,9.4c0.1,0.5,0.6,0.9,1.1,1
                        c0.6,0.1,1.1-0.1,1.5-0.4c0.7-0.5,1.3-0.9,1.9-1.4l0,0c0.5-0.4,0.8-0.6,1.1-0.6c0.3,0,0.6,0.2,1.1,0.6c1.8,1.3,3.3,2.8,4.5,4.2
                        c0.3,0.3,0.5,0.6,0.7,0.6c0.1,0,0.4-0.2,0.7-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.6-0.5,1.3-1.1,1.9-1.5C24.1,10.6,24.1,10.5,23.9,10.1z`}
                />
                <path
                    d={`M10.1,15.9c0.3-0.3,0.2-0.7,0.1-0.9c-0.2-0.3-0.4-0.5-0.9-0.5c0,0-0.1,0-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.2
                        c-0.5,0.5-1.1,1.1-1.7,1.7c-0.3,0.3-0.3,0.8,0,1.2C7.3,17.9,7.5,18,7.8,18c0.2,0,0.4-0.1,0.6-0.2C8.9,17.2,9.4,16.6,10.1,15.9z`}
                />
                <path
                    d={`M5.8,13c0.3-0.3,0.2-0.8-0.1-1.1c-0.2-0.2-0.4-0.3-0.6-0.3c-0.1,0-0.3,0-0.5,0.2C4,12.4,3.4,13,2.8,13.7
                        c-0.3,0.3-0.2,0.7-0.1,0.9c0.2,0.3,0.4,0.5,0.8,0.5c0.1,0,0.1,0,0.2-0.1C3.8,15,3.9,15,4,14.9C4.7,14.2,5.3,13.6,5.8,13z`}
                />
                <path
                    d={`M7.9,14.6c0.3-0.3,0.2-0.8-0.1-1.1c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2,0-0.3,0.1-0.5,0.2c-0.6,0.6-1.2,1.2-1.9,1.9
                        c-0.3,0.3-0.2,0.7-0.1,0.9c0.2,0.3,0.4,0.5,0.8,0.5c0.1,0,0.1,0,0.2-0.1c0.1,0,0.3-0.1,0.3-0.2C6.8,15.7,7.4,15.1,7.9,14.6z`}
                />
            </SvgIcon>
        );
    }
}
